import { inject, type Ref } from 'vue'
import { useRoute } from 'vue-router'
import {
  isMallPlatformOnlyPath,
  readMallUiScope,
  type MallUiScope
} from '@/layout/standalone/mallMenuScopes'
import { useMallStandaloneNav } from '@/hooks/web/useMallStandaloneNav'

/**
 * 自营视角下平台专属页（店铺管理 / 入驻）的页内兜底。
 * 壳层守卫为主；本钩子防止直链/非独立窗仍停在禁页。
 * @returns true 表示已发起跳转，调用方应中止后续加载
 */
export function useMallSelfPlatformOnlyGuard() {
  const route = useRoute()
  const injectedScope = inject<Ref<MallUiScope> | undefined>('mallUiScope', undefined)
  const { pushMall } = useMallStandaloneNav()

  const isSelfScope = () => (injectedScope?.value ?? readMallUiScope()) === 'self'

  function guardPlatformOnlyPage(): boolean {
    if (!isSelfScope()) {
      return false
    }
    if (!isMallPlatformOnlyPath(route.path)) {
      return false
    }
    void pushMall('/overview')
    return true
  }

  return { isSelfScope, guardPlatformOnlyPage }
}
